import { type Diagnostic, type ValidationRule } from '../types';

/**
 * Surfaces upstream subroutine graph errors (cycles, max-depth violations)
 * as diagnostics. The graph walk happens in the caller
 * (`fetchSubroutineGraph`); this rule converts each error into the
 * validator's diagnostic shape, preserving the optional `stepId` so the
 * editor warning icon attributes to the parent's offending CallSubroutine
 * step when available.
 */
export const subroutineGraphErrorsValidationRule: ValidationRule = {
  id: 'routine.subroutineGraphErrors',
  appliesTo: 'routine',
  run: ({ ctx }) => {
    const errors = ctx.subroutineGraphErrors;

    if (!errors || errors.length === 0) return [];

    return errors.map<Diagnostic>((e) => ({
      code: 'routine.subroutineGraphErrors',
      message: e.message,
      severity: 'error',
      stepId: e.stepId,
      sourceRule: 'routine.subroutineGraphErrors',
    }));
  },
};
